module.exports = __webpack_public_path__ + "img/back.b6092b4d.svg";